"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageIndicator = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../utils/CardHelper");
function PageIndicator(surveyId, currentPage, pageCount, getPageIndicatorAction, applicationgType = "msteams") {
    const pageColumns = new adaptivecards_1.ColumnSet();
    const fc = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { spacing: adaptivecards_1.Spacing.None, width: "stretch" });
    // Ensure non-empty string for the column/card to work on mobile Teams App
    fc.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, { text: " " }));
    pageColumns.addColumn(fc);
    for (let i = 0; i < pageCount; i++) {
        const col = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { spacing: adaptivecards_1.Spacing.None, width: "auto" });
        let imgUrl;
        const prefix = applicationgType === "msteams" ? "core_" : "";
        if (currentPage < i) {
            imgUrl = `https://static.polly.ai/teams/img/paging/${prefix}visited.png`;
        }
        else if (currentPage === i) {
            imgUrl = `https://static.polly.ai/teams/img/paging/${prefix}current.png`;
        }
        else {
            imgUrl = `https://static.polly.ai/teams/img/paging/${prefix}unvisited.png`;
        }
        let selectAction;
        if (getPageIndicatorAction) {
            selectAction = getPageIndicatorAction(surveyId, i);
        }
        col.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
            url: imgUrl,
            spacing: adaptivecards_1.Spacing.None,
            size: adaptivecards_1.Size.Auto,
            altText: `Question ${i}`,
            selectAction,
        }));
        pageColumns.addColumn(col);
    }
    const ec = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { spacing: adaptivecards_1.Spacing.None, width: "stretch" });
    // Ensure non-empty string for the column/card to work on mobile Teams App
    ec.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, { text: " " }));
    pageColumns.addColumn(ec);
    return pageColumns;
}
exports.PageIndicator = PageIndicator;
//# sourceMappingURL=PageIndicator.js.map